import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useCurrentUserId from './useCurrentUserId';

const useImagesInAlbum = (albumId: string | undefined) : string[] => {
  const userId = useCurrentUserId();
  const ruiDb = useSelector((state: RootState) => state.relationUserImageDb);
  const raiDb = useSelector((state: RootState) => state.relationAlbumImageDb);

  const ruiIds = Object.keys(ruiDb.relationUserImages).filter(id => ruiDb.relationUserImages[id].userId === userId);
  const idsByRuiIds = ruiIds.map(id => ruiDb.relationUserImages[id].imageId);

  const raiIds = Object.keys(raiDb.relationAlbumImages).filter(id => raiDb.relationAlbumImages[id].albumId === albumId);
  // make the array ascending by order
  raiIds.sort((a, b) => raiDb.relationAlbumImages[a].order - raiDb.relationAlbumImages[b].order);
  const idsByRaiIds = raiIds.map(id => raiDb.relationAlbumImages[id].imageId);

  const ids = idsByRaiIds.filter(id => idsByRuiIds.includes(id));

  return ids;
}

export default useImagesInAlbum;
